import {Checkbox, FormControlLabel, FormGroup} from '@mui/material'
import React, {FC, useEffect, useState} from 'react'
import {TooltipCustom} from './TooltipCustom'

type Props = {
  label: string
  defaultChecked: boolean
  handleCheckboxChecked?: (check: boolean, label: string) => void
  description?: string
  disable?: boolean
  showTooltip?: boolean
  insuranceFee?: string
  sumInsured?: string
  currencyFee?: string
}

export const CheckboxGroupBanCas: FC<Props> = ({
  label,
  defaultChecked,
  handleCheckboxChecked,
  description,
  showTooltip,
  disable,
  insuranceFee,
  sumInsured,
  currencyFee,
}) => {
  const [checked, setChecked] = useState(defaultChecked)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, label: string) => {
    setChecked(event.target.checked)
    if (handleCheckboxChecked) handleCheckboxChecked(event.target.checked, label)
  }

  useEffect(() => {
    setChecked(defaultChecked)
  }, [defaultChecked])

  return (
    <div className='field-wrapper'>
      <FormGroup
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: `${insuranceFee ? 'space-between' : 'inherit'}`,
          backgroundColor: `${
            insuranceFee && (insuranceFee != '0' || checked) ? '#f6f6f6' : 'inherit'
          }`,
          borderRadius: `${insuranceFee && (insuranceFee != '0' || checked) ? '5px' : 'inherit'}`,
          padding: `${insuranceFee && (insuranceFee != '0' || checked) ? '0 10px' : 'inherit'}`,
          lineHeight: '40px',
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={(event) => handleChange(event, label)}
              sx={{padding: '5px'}}
            />
          }
          label={label}
          disabled={disable}
          sx={{marginLeft: '-6px', maxWidth: '70%'}}
        />
        <div style={{display: 'flex'}}>
          {sumInsured && sumInsured != '0' && (
            <p style={{fontSize: '14px', fontWeight: '600'}}>
              Số tiền BH:{' '}
              <span style={{color: '#091A7A'}}>
                {sumInsured} {currencyFee ? currencyFee : 'đ'} {' '}
              </span>
            </p>
          )}
          {insuranceFee && insuranceFee != '0' && (
            <p style={{fontSize: '14px', fontWeight: '600'}}>
               - Phí:{' '}
              <span style={{color: '#091A7A'}}>
                {insuranceFee} {currencyFee ? currencyFee : 'đ'}
              </span>
            </p>
          )}
        </div>
        {!showTooltip && description && (
          <p style={{marginLeft: '20px', color: '#8f9296', fontSize: '12px'}}>{description}</p>
        )}
        {showTooltip && description && (
          <TooltipCustom label={description}>
            <p>(?)</p>
          </TooltipCustom>
        )}
      </FormGroup>
    </div>
  )
}
